import { apiRequest } from '../apiRequest';
import { 
  UPDATE_OBJECT_ENDPOINT, 
  FETCH_OBJECT_ENDPOINT, 
  FETCH_BOAT_TYPES_ENDPOINT, 
  FETCH_JETTY_TYPES_ENDPOINT,
  FETCH_DRIVE_TYPES_ENDPOINT
} from '../urls';

export const fetchObject = (data) => { 
  return apiRequest('POST', FETCH_OBJECT_ENDPOINT, data);
}

export const fetchBoatTypes = () => { 
  return apiRequest('GET', FETCH_BOAT_TYPES_ENDPOINT, {});
}

export const fetchJettyTypes = () => { 
  return apiRequest('GET', FETCH_JETTY_TYPES_ENDPOINT, {});
}

export const fetchDriveTypes = () => { 
  return apiRequest('GET', FETCH_DRIVE_TYPES_ENDPOINT, {});
}

export const updateObject = (data) => {
  return apiRequest('POST', UPDATE_OBJECT_ENDPOINT, data);
}

